/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Readiness_TitleInputs */

const cs_portals_readiness_title = /** @type {(inputs: Portals_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravenost`)
};

const en_portals_readiness_title = /** @type {(inputs: Portals_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readiness`)
};

/**
* | output |
* | --- |
* | "Readiness" |
*
* @param {Portals_Readiness_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_title = /** @type {((inputs?: Portals_Readiness_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_title(inputs)
	return cs_portals_readiness_title(inputs)
});